import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Media from 'local_modules/Media'
import actions from 'redux/actions'
import reduxForm from 'local_modules/redux-form'
import { required } from 'helpers/validation'
import { modals, localStorage } from 'helpers'

import Modal from 'components/Modal/Modal'
import Input from 'components/ui/form/Input/Input'
import Select from 'components/ui/form/Select/Select'
import Button from 'components/ui/Button/Button'
import CheckBox from 'components/form/CheckBox/CheckBox'
import TextArea from 'components/ui/form/TextArea/TextArea'
import { Grid, Cell } from 'components/layout/grid'
import Box from 'components/layout/Box/Box'

import s from './DialogWithFormModal.scss'


class DialogWithFormModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.DialogWithForm,
  }

  close = (isNotSubmit) => {
    const { name, fields } = this.props

    Object.keys(fields).forEach((fieldName) => {
      if (isNotSubmit) {
        localStorage.setItem(`dialogWithFormModal-${fieldName}`, fields[fieldName].value)
      }
      else {
        localStorage.removeItem(`dialogWithFormModal-${fieldName}`)
      }
    })

    actions.modals.close(name)
  }

  submit = (data) => {
    const { data: { onSubmit } } = this.props

    this.close(false)
    onSubmit(data)
  }

  render() {
    const { data, fields, submitForm, updateFieldValues } = this.props

    return (
      <Modal onClose={this.close}>
        <div>
          <div className={s.title}>{data.title}</div>
          {
            Boolean(data.text) && (
              <Box pt="sm">
                <div className={s.text}>{data.text}</div>
              </Box>
            )
          }
          <Media mobile>
            {
              (isMobile) => (
                <Grid columns={data.columns || 8} gutter="md">
                  {
                    data.fields.map(({ fieldType, fieldName, placeholder, values, label, size, mobileSize }) => {
                      const isInput     = fieldType === 'input' || fieldType === 'date'
                      const isTextArea  = fieldType === 'textArea'
                      const isSelect    = fieldType === 'select'
                      const isCheckbox  = fieldType === 'checkbox'
                      const cellSize    = (isMobile ? mobileSize : size) || 8

                      if (isInput) {
                        return (
                          <Cell key={fieldName} size={cellSize}>
                            <Input
                              className={s.input}
                              valueLink={fields[fieldName]}
                              placeholder={placeholder}
                              label={label}
                              type={fieldType === 'date' ? fieldType : 'text'}
                            />
                          </Cell>
                        )
                      }

                      if (isTextArea) {
                        return (
                          <Cell key={fieldName} size={cellSize}>
                            <TextArea
                              className={s.input}
                              valueLink={fields[fieldName]}
                              placeholder={placeholder}
                              label={label}
                            />
                          </Cell>
                        )
                      }

                      if (isSelect) {
                        return (
                          <Cell key={fieldName} size={cellSize}>
                            <Select
                              className={s.input}
                              valueLink={fields[fieldName]}
                              placeholder={placeholder}
                              label={label}
                              options={values}
                            />
                          </Cell>
                        )
                      }

                      if (isCheckbox) {
                        return (
                          <Cell key={fieldName} size={cellSize}>
                            <CheckBox
                              className={s.input}
                              valueLink={fields[fieldName]}
                              label={placeholder}
                              onClick={(value) => updateFieldValues({ [fieldName]: value })}
                            />
                          </Cell>
                        )
                      }

                      return (
                        <Cell key={fieldName} size={cellSize}>
                          {fieldType}
                        </Cell>
                      )
                    })
                  }
                  <Cell size={data.columns || 8}>
                    <Button
                      className={s.button}
                      title={data.buttonTitle || 'Ок'}
                      green
                      fullWidth
                      onClick={submitForm(this.submit)}
                    />
                  </Cell>
                </Grid>
              )
            }
          </Media>
          {
            Boolean(data.bottomText) && (
              <Box pt="sm">
                <div className={s.text} dangerouslySetInnerHTML={{ __html: data.bottomText }} />
              </Box>
            )
          }
        </div>
      </Modal>
    )
  }
}


export default reduxForm((props) => {
  const { data } = props

  const fields        = {}
  const initialValues = {}

  data.fields.forEach(({ fieldName, value = '', validation }) => {
    fields[fieldName]         = [ validation ? validation(required) : required ]
    initialValues[fieldName]  = value || localStorage.getItem(`dialogWithFormModal-${fieldName}`, value)
  })

  return {
    name: 'dialogWithFormModalForm',
    fields,
    initialValues: () => initialValues,
  }
})(DialogWithFormModal)
